import { getCurrentInstance, ComponentInstance } from 'vue-demi';

/**
 * Allow access to Vue root instance from anywhere.
 * Also provide a place to store global variables like "OR Config".
 * TODO: Might be removed after updating libraries like "vuex" or "vue-router"?
 */
export const useGlobalVars = () => {
  const VM_REF = Symbol.for('VM_REF');

  const initializeVueRef = () => {
    if (!(window as any)[VM_REF]) {
      (window as any)[VM_REF] = getCurrentInstance()!.proxy.$root;
      (window as any)[VM_REF].$global = {};
    }
  };

  const getVueRef = () => (window as any)[VM_REF] as ComponentInstance;
  const getVueGlobals = () => getVueRef().$global;

  return { initializeVueRef, getVueRef, getVueGlobals };
};
